
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { HttpErrorService } from '../shared/http-error.service';

@Component({
  selector: 'app-login-no-privacy-policy',
  templateUrl: './login-no-privacy-policy.component.html',
  styleUrls: ['./login-no-privacy-policy.component.css'],
  imports: [
    FormsModule
],
  standalone: true
})
export class LoginNoPrivacyPolicyComponent implements OnInit, OnDestroy {
  err: HttpErrorResponse;

  public waitingForLoginValidation = false;
  public blockedRemainingSeconds = 0;
  public invalidPin = false;
  private blockedInterval: any;
  @ViewChild('pincode') public pincode: ElementRef;

  constructor(
    private authService: AuthService,
    private route: Router,
    private httpErrorService: HttpErrorService
  ) { }

  ngOnInit(): void {
    this.httpErrorService.getError().subscribe((err) => {
      this.err = err;
    });
  }

  ngOnDestroy(): void {
    if (this.blockedInterval) {
      clearInterval(this.blockedInterval);
    }
  }

  async onSubmit(form) {
    this.invalidPin = false;
    const pin = this.pincode.nativeElement.value.toUpperCase();
    this.authService.setPin(pin);
    this.authService.login().subscribe((value) => {
      if (value.status === 'accept') {
        const localStorageObject = this.authService.getPrmWebAppLastUrl();
        const authData = this.authService.getAuthData();

        if (
          localStorageObject &&
          ['/auth', "/pv44"].indexOf(localStorageObject.url) < 0 &&
          localStorageObject.pin === authData.pin &&
          localStorageObject.iPadId === authData.iPadId
        ) {

          this.route.navigate([localStorageObject.url]);
          return;
        }

        if (
          window.location.hostname !== 'localhost' &&
          window.location.pathname.indexOf('/webapp/' + value.lang) < 0
        ) {
          // wrong language frontend loaded switching
          if (authData.role === 'moderator' || authData.role === 'observer') {
            window.location.href = '/webapp/' + value.lang + '/#/observer/introduction/docs';
          } else if (authData.role === 'participant') {
            window.location.href = '/webapp/' + value.lang + '/#/participant/introduction/docs';
          }
        } else if (authData.role === 'moderator' || authData.role === 'observer') {
          this.route.navigate(['/observer/introduction/docs']);
        } else if (authData.role === 'participant') {
          this.route.navigate(['/participant/introduction/docs']);
        }
      }
      if (value.status === 'decline') {
        this.err = new HttpErrorResponse({ status: 401 });
      }
      if (value.status === 'invalidpin') {
        this.invalidPin = true;
      }
      if (value.status === 'blocked') {
        this.startBlockedCountdown(value.lockedUntil);
      }
      this.waitingForLoginValidation = false;
    });
    this.waitingForLoginValidation = true;
  }

  private startBlockedCountdown(lockedUntil: string | undefined) {
    if (lockedUntil == null) {
      return;
    }
    if (this.blockedInterval) {
      clearInterval(this.blockedInterval);
    }
    const lockedUntilDate = new Date(lockedUntil);
    const update = () => {
      const diffSeconds = Math.max(0, Math.round((lockedUntilDate.getTime() - Date.now()) / 1000));
      this.blockedRemainingSeconds = diffSeconds;
      if (diffSeconds <= 0) {
        clearInterval(this.blockedInterval);
        this.blockedInterval = null;
      }
    };
    update();
    this.blockedInterval = setInterval(update, 1000);
  }

  public get isBlocked(): boolean {
    return this.blockedRemainingSeconds > 0;
  }

  public get blockedCountdownText(): string {
    const minutes = Math.floor(this.blockedRemainingSeconds / 60);
    const seconds = this.blockedRemainingSeconds % 60;
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

  public onPinInput(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
  }
}